import { Icon, IconNames } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ButtonHTMLAttributes } from 'react';

import styles from './footerItem.module.scss';

export const FooterItem = ({
  icon,
  className,
  children,
  ...buttonProps
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconNames;
}): JSX.Element => (
  <li>
    <button
      className={classnames(styles.sidebarFooterButton, className)}
      {...buttonProps}
    >
      <Icon name={icon} size={20} className={styles.sidebarFooterButtonIcon} />
      <span className={styles.sidebarFooterButtonName}>{children}</span>
    </button>
  </li>
);
